import { ICrmChatNote } from '../../../shared/interfaces/crm-chat-note.interface';
import { IChatNoteEntityApi } from '../interfaces/api/chat-note.interface';

export const chatNoteApiMapper = (
  chatNote: IChatNoteEntityApi,
): ICrmChatNote => {
  return {
    id: chatNote.activityid,
    subject: chatNote.subject,
    activitytypecode: chatNote.activitytypecode,
    createdon: new Date(chatNote.createdon),
    solgari_channelprovider: chatNote.solgari_channelprovider,
    solgari_fromraw: chatNote.solgari_fromraw,
    solgari_toraw: chatNote.solgari_toraw,
    solgari_solgariconversationid: chatNote.solgari_solgariconversationid,
    ownerId: chatNote._ownerid_value,
  };
};
